import React from 'react';
import { Check } from 'lucide-react';
import { useI18n } from '../i18n/I18nProvider';
import { useBookersContent } from '../hooks/useBookersContent';

export default function Solutions() {
  const { t } = useI18n();
  const { solutions } = useBookersContent();

  return (
    <section id="solutions" className="mx-auto max-w-7xl px-5 lg:px-8 section-pad">
      <div className="text-center max-w-2xl mx-auto reveal">
        <p className="text-sm font-semibold text-[#76B828]">{t('solutions.eyebrow')}</p>
        <h2 className="font-display text-4xl md:text-5xl mt-3 text-[#0b0b0f]">{t('solutions.title')}</h2>
        <p className="text-[#55555f] mt-4 text-lg">{t('solutions.description')}</p>
      </div>

      <div className="space-y-20 mt-16">
        {solutions.map((sol, idx) => (
          <div key={sol.key} className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            <div className={`reveal ${idx % 2 === 1 ? 'lg:order-2' : ''}`}>
              <div className="relative rounded-[1.75rem] overflow-hidden border border-black/5 shadow-[0_30px_80px_rgba(15,15,20,0.12)]">
                <img src={sol.image} alt={sol.title} className="w-full h-[320px] md:h-[400px] object-cover" />
              </div>
            </div>
            <div className={`reveal ${idx % 2 === 1 ? 'lg:order-1' : ''}`}>
              <span className="inline-flex h-12 w-12 rounded-xl bg-[#EEF6DC] items-center justify-center">
                <sol.icon size={24} className="text-[#76B828]" />
              </span>
              <h3 className="font-display text-3xl md:text-4xl mt-5 text-[#0b0b0f]">{sol.title}</h3>
              <p className="text-[#55555f] mt-3 text-lg">{sol.lead}</p>
              <div className="mt-7 space-y-5">
                {sol.points.map((p) => (
                  <div key={p.title} className="flex gap-4">
                    <span className="mt-0.5 h-7 w-7 shrink-0 rounded-full bg-[#e9f9f0] flex items-center justify-center">
                      <Check size={15} className="text-[#16a34a]" />
                    </span>
                    <div>
                      <p className="font-semibold text-[#0b0b0f]">{p.title}</p>
                      <p className="text-[#6b6b73] mt-1 text-[15px] leading-relaxed">{p.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
